import { cva } from 'class-variance-authority';

export const checkboxVariants = cva(['inline-flex', 'flex-col']);

export const checkboxContainerVariants = cva(['inline-flex', 'items-center', 'gap-sm'], {
  variants: {
    disabled: {
      true: 'opacity-40 cursor-not-allowed',
      false: 'cursor-pointer',
    },
  },
  defaultVariants: {
    disabled: false,
  },
});

export const checkboxWrapperVariants = cva(
  [
    'relative',
    'inline-flex',
    'items-center',
    'justify-center',
    'shrink-0',
    'rounded',
    'border',
    'transition-colors',
  ],
  {
    variants: {
      scale: {
        s: 'size-3',
        m: 'size-3.5',
        l: 'size-4',
      },
      status: {
        idle: '',
        invalid: '',
      },
      checked: {
        true: '',
        false: '',
      },
      disabled: {
        true: '',
        false: '',
      },
    },
    compoundVariants: [
      {
        status: 'idle',
        checked: false,
        className: 'bg-surface border-outline-input',
      },
      {
        status: 'idle',
        checked: false,
        disabled: false,
        className: 'hover:border-foreground',
      },
      {
        status: 'idle',
        checked: true,
        className: 'bg-brand border-brand',
      },
      {
        status: 'idle',
        checked: true,
        disabled: false,
        className: 'hover:bg-brand-hover hover:border-brand-hover',
      },
      {
        status: 'invalid',
        checked: false,
        className: 'bg-surface border-status-danger',
      },
      {
        status: 'invalid',
        checked: true,
        className: 'bg-status-danger border-status-danger',
      },
    ],
    defaultVariants: {
      scale: 'm',
      status: 'idle',
      checked: false,
      disabled: false,
    },
  }
);

/**
 * The invisible input overhangs the box to a 24px target, the launch build rules'
 * minimum, so a checkbox without a label is still easy to hit.
 */
export const checkboxInputVariants = cva(
  ['absolute', 'opacity-0', 'cursor-pointer', 'disabled:cursor-not-allowed', 'm-0'],
  {
    variants: {
      scale: {
        s: '-inset-1.5', // 12px box
        m: '-inset-[5px]', // 14px box
        l: '-inset-1', // 16px box
      },
    },
    defaultVariants: {
      scale: 'm',
    },
  }
);

export const checkboxIconVariants = cva(['text-surface', 'pointer-events-none'], {
  variants: {
    visible: {
      true: 'block',
      false: 'hidden',
    },
    scale: {
      s: 'size-2.5',
      m: 'size-3',
      l: 'size-3.5',
    },
  },
  defaultVariants: {
    visible: false,
    scale: 'm',
  },
});

export const checkboxLabelVariants = cva(
  ['select-none', 'font-inter', 'font-normal', 'text-foreground'],
  {
    variants: {
      scale: {
        s: 'text-xs leading-[18px]',
        m: 'text-sm leading-[22px]',
        l: 'text-base leading-[24px]',
      },
      disabled: {
        true: '',
        false: '',
      },
    },
    defaultVariants: {
      scale: 'm',
      disabled: false,
    },
  }
);

export const checkboxRequiredVariants = cva([
  'text-status-danger',
  'font-medium',
  'leading-[16px]',
  'ml-xxxs',
]);

export const checkboxHelperTextVariants = cva(['text-xs', 'mt-xxs', 'font-inter'], {
  variants: {
    status: {
      idle: 'text-foreground-secondary',
      invalid: 'text-status-danger',
    },
  },
  defaultVariants: {
    status: 'idle',
  },
});
